import { useEffect, useState } from 'react';

/**
 * Tracks the on-screen keyboard through `visualViewport`: `bottom` is how far
 * the layout viewport extends below the visible one, `height` is the visible
 * height. Both stay 0 where `visualViewport` is unavailable.
 */
export function useKeyboardInset(): { bottom: number; height: number } {
  const [viewport, setViewport] = useState({ bottom: 0, height: 0 });

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const update = () =>
      setViewport({
        bottom: Math.max(0, window.innerHeight - vv.height - vv.offsetTop),
        height: vv.height,
      });
    update();
    vv.addEventListener('resize', update);
    // iOS changes `offsetTop` on scroll, not on resize.
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return viewport;
}
